// Cart utility functions for managing cart state across components

export const getCartItems = () => {
  try {
    const savedCart = localStorage.getItem('cart');
    return savedCart ? JSON.parse(savedCart) : [];
  } catch (error) {
    console.error('Error loading cart:', error);
    return [];
  }
};

export const addToCart = (product) => {
  try {
    const currentCart = getCartItems();
    const existingItemIndex = currentCart.findIndex(item => item.id === product.id);
    
    if (existingItemIndex >= 0) {
      // Item already exists, increment quantity
      currentCart[existingItemIndex].quantity += 1;
    } else {
      // Add new item with quantity 1
      currentCart.push({
        ...product,
        quantity: 1,
        isLiked: false
      });
    }
    
    localStorage.setItem('cart', JSON.stringify(currentCart));
    return currentCart;
  } catch (error) {
    console.error('Error adding to cart:', error);
    return getCartItems();
  }
};

export const updateCartItemQuantity = (productId, change) => {
  try {
    const currentCart = getCartItems();
    const updatedCart = currentCart.map(item => {
      if (item.id === productId) {
        const newQuantity = item.quantity + change;
        if (newQuantity <= 0) {
          return null; // Remove item if quantity becomes 0
        }
        return { ...item, quantity: newQuantity };
      }
      return item;
    }).filter(Boolean); // Remove null items

    localStorage.setItem('cart', JSON.stringify(updatedCart));
    return updatedCart;
  } catch (error) {
    console.error('Error updating cart quantity:', error);
    return getCartItems();
  }
};

export const removeFromCart = (productId) => {
  try {
    const currentCart = getCartItems();
    const updatedCart = currentCart.filter(item => item.id !== productId);
    localStorage.setItem('cart', JSON.stringify(updatedCart));
    return updatedCart;
  } catch (error) {
    console.error('Error removing from cart:', error);
    return getCartItems();
  }
};

export const clearCart = () => {
  try {
    localStorage.removeItem('cart');
    return [];
  } catch (error) {
    console.error('Error clearing cart:', error);
    return [];
  }
};

export const isInCart = (productId) => {
  const cartItems = getCartItems();
  return cartItems.some(item => item.id === productId);
};

export const getCartItemQuantity = (productId) => {
  const cartItems = getCartItems();
  const item = cartItems.find(item => item.id === productId);
  return item ? item.quantity : 0;
};

export const getCartTotal = () => {
  const cartItems = getCartItems();
  return cartItems.reduce((total, item) => {
    const price = item.SalePrice || item.Price;
    return total + (price * item.quantity);
  }, 0);
};

export const getCartItemCount = () => {
  const cartItems = getCartItems();
  return cartItems.reduce((count, item) => count + item.quantity, 0);
};
